import React from "react";
import { CatalogContext } from "../Translator/withTranslation";
import { RenderContext } from "../Context/Ssr";
import { LocaleContext } from "../Context/Locale";
import { CurrencyContext } from "../Context/Currency";
import styled from "@emotion/styled";

const SeoContentContainer = styled.div`
    max-width:1600px;
`;
const SeoContentComponent = (props) => {
    return(
            props.content != '' &&
            <SeoContentContainer
                className={(props.className ? props.className : 'container-fluid z-index-0 mb-4')}
                style={(props.style ? props.style : { })}>
                {props.url ?
                <FetchHTML url={this.props.url} />
                :
                <div dangerouslySetInnerHTML={{__html: props.seo.content}} />
                }
            </SeoContentContainer>
        );
}

export const SeoContent = (initialProps, context) => {
    return (
        <LocaleContext.Provider value={initialProps.locale}>
            <CatalogContext.Provider value={initialProps.catalog}>
            <RenderContext.Provider value={context}>
                <CurrencyContext.Provider value={initialProps.currency}>
                    <SeoContentComponent { ...initialProps} />
                </CurrencyContext.Provider>
            </RenderContext.Provider>
            </CatalogContext.Provider>
        </LocaleContext.Provider>
    );
}